"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MediaThumbnail = void 0;

var jsx_runtime_1 = require("react/jsx-runtime");

var react_1 = require("react");

var AddressView_1 = require("../components/AddressView");

var MediaObject_1 = require("../components/MediaObject");

var useMediaContext_1 = require("../context/useMediaContext");

var NFTDataContext_1 = require("../context/NFTDataContext");

var getContentDataOptions_1 = require("../utils/getContentDataOptions");

var MediaThumbnail = function MediaThumbnail(_ref) {
  var _ref$getContentData = _ref.getContentData,
      getContentData = _ref$getContentData === void 0 ? getContentDataOptions_1.defaultGetContentData : _ref$getContentData,
      className = _ref.className;

  var _react_1$useContext = react_1.useContext(NFTDataContext_1.NFTDataContext),
      data = _react_1$useContext.nft.data,
      metadata = _react_1$useContext.metadata.metadata;

  var _useMediaContext_1$us = useMediaContext_1.useMediaContext(),
      getStyles = _useMediaContext_1$us.getStyles,
      getString = _useMediaContext_1$us.getString;

  var getContent = function getContent() {
    if (metadata && data) {
      return {
        media: jsx_runtime_1.jsx(MediaObject_1.MediaObject, Object.assign({}, getContentData(data, metadata)), void 0),
        title: metadata.name
      };
    }

    return {
      media: jsx_runtime_1.jsx("div", Object.assign({}, getStyles("mediaLoader")), void 0),
      title: "..."
    };
  };

  var _getContent = getContent(),
      media = _getContent.media,
      title = _getContent.title;

  var hasCreator = data === null || data === void 0 ? void 0 : data.nft.creator;
  var address = hasCreator ? data === null || data === void 0 ? void 0 : data.nft.creator : data === null || data === void 0 ? void 0 : data.nft.owner;
  return jsx_runtime_1.jsxs("div", Object.assign({
    className: className
  }, {
    children: [jsx_runtime_1.jsx("div", Object.assign({}, getStyles("cardMediaWrapper"), {
      children: media
    }), void 0), jsx_runtime_1.jsxs("div", Object.assign({}, getStyles("cardItemInfo"), {
      children: [jsx_runtime_1.jsx("h5", Object.assign({}, getStyles("cardTitle"), {
        children: title
      }), void 0), jsx_runtime_1.jsxs("div", {
        children: [jsx_runtime_1.jsx("span", Object.assign({}, getStyles("textSubdued"), {
          children: hasCreator ? getString("CARD_CREATED_BY") : getString("CARD_OWNED_BY")
        }), void 0), " ", jsx_runtime_1.jsx("span", {
          children: address && jsx_runtime_1.jsx(AddressView_1.AddressView, {
            address: address
          }, void 0)
        }, void 0)]
      }, void 0)]
    }), void 0)]
  }), void 0);
};

exports.MediaThumbnail = MediaThumbnail;